import IDEContent from './IDEContent';
export default IDEContent;
